export const defaultApiVersion = 20230101;
